import React, { useState, useEffect, useRef } from "react";
import "./Template_2.css";

const Template_2_Reviews = () => {
  const reviews = [
    {
      text: "The Maldives package was absolutely incredible. The resort was even better than pictured, and the staff went above and beyond to make our stay memorable. Will definitely book with VoyageVista again!",
      author: "Sarah Johnson",
      role: "Maldives Traveler",
      image: "https://randomuser.me/api/portraits/women/65.jpg",
      rating: 5,
    },
    {
      text: "Our family trip to Bali was perfectly organized. The activities were engaging for both kids and adults, and the guides were knowledgeable and friendly. Thanks for the wonderful memories!",
      author: "Michael Chen",
      role: "Family Traveler",
      image: "https://randomuser.me/api/portraits/men/32.jpg",
      rating: 5,
    },
    {
      text: "The pilgrimage tour to Varanasi was a spiritually enriching experience. The accommodations were comfortable, and the itinerary perfectly balanced sightseeing with spiritual activities. Highly recommended!",
      author: "Priya Sharma",
      role: "Pilgrimage Traveler",
      image: "https://randomuser.me/api/portraits/women/44.jpg",
      rating: 4.5,
    },
    {
      text: "The European tour exceeded all our expectations. Every detail was perfectly planned, and we got to experience authentic local culture. Worth every penny!",
      author: "James Wilson",
      role: "Europe Explorer",
      image: "https://randomuser.me/api/portraits/men/76.jpg",
      rating: 5,
    },
    {
      text: "Our honeymoon in Santorini was magical thanks to VoyageVista. The private villa with caldera view was breathtaking and the romantic dinners were perfectly arranged.",
      author: "Emma Thompson",
      role: "Honeymooner",
      image: "https://randomuser.me/api/portraits/women/26.jpg",
      rating: 4.8,
    },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const autoScrollRef = useRef(null);

  // Handle automatic scrolling
  useEffect(() => {
    if (isPaused) return;

    autoScrollRef.current = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === reviews.length - 1 ? 0 : prevIndex + 1
      );
    }, 4000); // Change review every 4 seconds

    return () => clearInterval(autoScrollRef.current);
  }, [reviews.length, isPaused]);

  const handlePrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? reviews.length - 1 : prevIndex - 1
    );
    resetAutoScroll();
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === reviews.length - 1 ? 0 : prevIndex + 1
    );
    resetAutoScroll();
  };

  const goToReview = (index) => {
    setCurrentIndex(index);
    resetAutoScroll();
  };

  const resetAutoScroll = () => {
    setIsPaused(true);
    clearInterval(autoScrollRef.current);
    setTimeout(() => setIsPaused(false), 8000); // Resume after 8 seconds
  };

  const handleMouseEnter = () => {
    setIsPaused(true);
    clearInterval(autoScrollRef.current);
  };

  const handleMouseLeave = () => {
    setIsPaused(false);
  };

  const renderStars = (rating) => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 !== 0;

    for (let i = 0; i < fullStars; i++) {
      stars.push(<i key={i} className="fas fa-star"></i>);
    }

    if (hasHalfStar) {
      stars.push(<i key="half" className="fas fa-star-half-alt"></i>);
    }

    const emptyStars = 5 - Math.ceil(rating);
    for (let i = 0; i < emptyStars; i++) {
      stars.push(<i key={`empty-${i}`} className="far fa-star"></i>);
    }

    return stars;
  };

  return (
    <section id="reviews" className="Template_2 section Template_2 reviews">
      <div className="Template_2 container">
        <div className="Template_2 section-title">
          <h2>Traveler Testimonials</h2>
          <p>See what our travelers have to say about their experiences</p>
        </div>

        <div
          className="Template_2 reviews-carousel-container"
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <div className="Template_2 reviews-carousel">
            {reviews.map((review, index) => (
              <div
                key={index}
                className={`Template_2 review-slide ${
                  index === currentIndex ? "active" : ""
                }`}
              >
                <div className="Template_2 review-card">
                  <div className="Template_2 review-text">
                    <p>{review.text}</p>
                  </div>
                  <div className="Template_2 review-author">
                    <img src={review.image} alt={review.author} />
                    <div>
                      <h4>{review.author}</h4>
                      <p>{review.role}</p>
                      <div className="Template_2 review-rating">
                        {renderStars(review.rating)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="Template_2 carousel-controls">
            <button
              className="Template_2 carousel-button prev"
              onClick={handlePrev}
              aria-label="Previous review"
            >
              <i className="fas fa-chevron-left"></i>
            </button>

            <div className="Template_2 carousel-indicators">
              {reviews.map((_, index) => (
                <button
                  key={index}
                  className={`Template_2 indicator ${
                    index === currentIndex ? "active" : ""
                  }`}
                  onClick={() => goToReview(index)}
                  aria-label={`Go to review ${index + 1}`}
                />
              ))}
            </div>

            <button
              className="Template_2 carousel-button next"
              onClick={handleNext}
              aria-label="Next review"
            >
              <i className="fas fa-chevron-right"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Template_2_Reviews;
